import { useContext } from 'react'

import { Form } from 'components/ui/form/Form'
import KitForm from 'components/parts/KitForm'
import { kitWithItemsValidation } from 'util/validations'
import { useEditKit } from 'hooks/mutations'
import { DocumentTextIcon } from '@heroicons/react/24/outline'
import { ModalContext } from 'context/ModalContext'
import { Card } from 'components/gsys-ui'

const EditKitModal = ({ initial, kitId }) => {
  const modal = useContext(ModalContext)
  const mutation = useEditKit(kitId)

  return (
    <Card className="m-auto">
      <Card.Title Icon={DocumentTextIcon}>Edit a kit</Card.Title>
      <Card.Body>
        <Form
          validation={kitWithItemsValidation}
          initial={initial}
          mutation={mutation}
          FormComp={KitForm}
          onSubmit={modal.close}
        />
      </Card.Body>
    </Card>
  )
}

export default EditKitModal